import React from 'react'
import { withRouter, Route, Redirect } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import Cookies from 'js-cookie'
import { addUserInfo } from '../../redux/reducers/baseInfo'

const setSaviorPageData = (page: {
	pagename: string
	eventtype: string
	eventid: string
	eventname: string
}) => {
	const setSaviorData = (window as any).setSaviorData
	if (typeof setSaviorData === 'function') {
		setSaviorData({ page })
	}
}

const AuthRoute: React.FC<any> = ({ children, ...rest }) => {
	const dispatch = useDispatch()
	return (
		<Route
			{...rest}
			render={({ location }) => {
				const token = Cookies.get('access_token')
				if (!token) { // 未登录
					localStorage.clear()
					dispatch(addUserInfo({workid: ''}))
					// console.log(location.pathname,location.search.indexOf('?code=') > -1)
					return ['/', '/index', '/login', '/review'].includes(location.pathname)
						? children
						:
						<Redirect
							to={{
								pathname: '/login',
								state: { from: location }
							}}
						/>
				} else {
					console.log(location.pathname,'location')
					if (location.pathname === '/main/review/newMedia') {
						setSaviorPageData({
							pagename: 'dahotelpage', // 可选值
							eventtype: 'show', // 必传 click show close info
							eventid: '100659', // 可选值 需要申请
							eventname: 'dahotelpageshow', // 可选值 产品定义
						})
					}else if(location.pathname.includes('/main/review/waitReview/index')){
						setSaviorPageData({
							pagename: 'damarketpage', // 可选值
							eventtype: 'show', // 必传 click show close info
							eventid: '100660', // 可选值 需要申请
							eventname: 'damarketpageshow', // 可选值 产品定义
						})
					}else if(location.pathname === '/index'){
						setSaviorPageData({
							pagename: 'dahomepage', // 可选值
							eventtype: 'show', // 必传 click show close info
							eventid: '100658', // 可选值 需要申请
							eventname: 'dahomepageshow', // 可选值 产品定义
						})
					}
					return children
				}
			}}
		/>
	)
}

export default connect()(withRouter(AuthRoute))
